module.exports = __webpack_public_path__ + "static/img/left_text.734c1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/left_text.png
// module id = dWAn
// module chunks = 12